require('./starrr.js');
require('./sidr/sidr.min.js');
